import ArrayUtils from '../../utils/ArrayUtils'
import GraphicsUtils from '../../utils/GraphicsUtils'
import Point from '../../geom/Point'

var DEAD_AREA_RESULT = new Point(-1, -1);

function DeadAreaProjection(deadAreas, chainedProjection) {
    this._deadAreas = ArrayUtils.copy(deadAreas);
    this._chainedProjection = chainedProjection;
}

DeadAreaProjection.prototype.locationToPoint = function(location, skipArea = false) {
    var point = this._chainedProjection.locationToPoint(location, skipArea);
    if (!skipArea) {
        point = this.validatePointForDeadAreas(point);
    }
    return point;
};

DeadAreaProjection.prototype.pointToLocation = function(point, skipArea = false) {
    var location = this._chainedProjection.pointToLocation(point, skipArea);
    return location;
};

DeadAreaProjection.prototype.validatePointForDeadAreas = function(point) {
    if (this._deadAreas) {
        for (var i = 0; i < this._deadAreas.length; i++) {
            if (this.isPointInDeadArea(point, this._deadAreas[i])) {
                return DEAD_AREA_RESULT;
            }
        }
    }
    return point;
};

DeadAreaProjection.prototype.isPointInDeadArea = function(point, deadArea) {
    return GraphicsUtils.isPointInPolygon(point, deadArea.shapePoints);
};

export default DeadAreaProjection;